var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.802 15.4904C35.877 7.02036 28.4887 3.20703 21.9987 3.20703C21.9987 3.20703 21.9987 3.20703 21.9804 3.20703C15.5087 3.20703 8.10204 7.00203 6.17704 15.472C4.03204 24.932 9.82538 32.9437 15.0687 37.9854C17.012 39.8554 19.5054 40.7904 21.9987 40.7904C24.492 40.7904 26.9854 39.8554 28.9104 37.9854C34.1537 32.9437 39.947 24.9504 37.802 15.4904ZM21.9987 24.6754C18.8087 24.6754 16.2237 22.0904 16.2237 18.9004C16.2237 15.7104 18.8087 13.1254 21.9987 13.1254C25.1887 13.1254 27.7737 15.7104 27.7737 18.9004C27.7737 22.0904 25.1887 24.6754 21.9987 24.6754Z",
    fill: "#2D96BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic-location.f248998c1590658a4eac5d8dab2c41b9.svg";
export { ForwardRef as ReactComponent };